

<div class="modal-body">
	<div class="center">
		<i class="fa fa-check-circle" aria-hidden="true"></i>
		<h5 class="text-success">Successfully logged in!</h5>
	</div>
	
</div>